export function customSelect() {
    if ($("select").length) {
        jcf.setOptions("Select", {
            wrapNative: false,
            flipDropToFit:false,
            fakeDropInBody: false,
            maxVisibleItems: 5
        });

        jcf.replaceAll();
    }

    $('.contacts-form select').each(function () {
        $(this).find('option:first').attr('disabled', 'disabled');
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/customSelect.js